import { FUNCTIONS_URL } from "./supabase";

export const callFunction = async (
  path: string,
  init: RequestInit = {}
): Promise<unknown> => {
  const headers = new Headers(init.headers);
  if (!headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  const response = await fetch(`${FUNCTIONS_URL}${path}`, {
    ...init,
    headers,
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message =
      data && typeof data === "object" && "error" in data
        ? String((data as { error?: string }).error)
        : "Request failed";
    throw new Error(message || "Request failed");
  }

  return data;
};
